import { render, staticRenderFns } from "./HeatingBuildingType.vue?vue&type=template&id=06db0c54"
import script from "./HeatingBuildingType.vue?vue&type=script&lang=ts"
export * from "./HeatingBuildingType.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports